import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {useState, useEffect} from "react";
import "./HaveQuestion.css";
import { PowerProgress } from "../../../../../utils/apis/homepage";

export default function HaveQuestion() {

  const [appsetup, setAppSetup] = useState([]);

  const getAppSetup = async () => {
      const res = await PowerProgress();
      if (res?.success) {
        setAppSetup(res?.data?.[0]);
      }
    };
    useEffect(() => {
      getAppSetup();
    }, []);

  return (
    <section className="have-question-section container">
      <img
        src="/assets/images/effects/contact-banner.png"
        alt="banner"
        className="bg-image"
      />
      <div className="overlay"></div>
      <div className="content-wrapper">
        <div className="left-content">
          <h1 className="title">Have a Question?</h1>

          <p className="red-title">
            Share your needs & get the best solution tailored for you
          </p>
          <div className="divide-div"></div>
          <div className="contact-wrapper">
            <div className="mobile-no">
              <div className="icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              {/* <span>+91 91234 56789</span> */}
              <span>{appsetup?.contact_no}</span>
            </div>

            <div className="mobile-no">
              <div className="icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              {/* <span>+91 91234 56789</span> */}
              <span>{appsetup?.alt_contact_no}</span>
            </div>

            <div className="email">
              <div className="icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              {/* <span>Support@Yourbrand.Com</span> */}
              <span>{appsetup?.email}</span>
            </div>
          </div>
        </div>

        <div className="right-image">
          <div className="absolute-div">
            <img src="/assets/images/effects/person.png" alt="person" />
          </div>
        </div>
      </div>
    </section>
  );
}
